import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Modal,
  Input,
  Table,
  Button,
} from "reactstrap"
import MetaTags from "react-meta-tags"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {
  getKBentries,
  getKBentriesSuccess,
  setKBentries,
  getSelectedKBentry,
  uploadKB,
  editKB,
  deleteKB,
  setUploadKBSuccess,
  setEditKBSuccess,
  setDeleteKBsuccess,
  setSelectedKBentries,
  setSelectedKBentriesSuccess,
} from "store/old/kb/actions"
//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb"
import toastr from "toastr"
import Swal from "sweetalert2"
import "toastr/build/toastr.min.css"
import store from "../../store/index"
import "react-phone-number-input/style.css"
import LoadingSpinner from "components/Reports/EditReports/EditTables/loader"
import jwt from "jsonwebtoken"
import ReactPaginate from "react-paginate"


const KnowledgeBase = () => {
  const decodeToken = token => {
    try {
      const decodedToken = jwt.decode(token)
      return decodedToken
    } catch (error) {
      console.log("Error decoding token:", error)
      return null
    }
  }

  const token = localStorage.getItem("authUser")
  const decodedToken = decodeToken(JSON.parse(token))
  let role = decodedToken.role

  const dispatch = useDispatch()
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 1500,
    timerProgressBar: true,
    didOpen: toast => {
      toast.addEventListener("mouseenter", Swal.stopTimer)
      toast.addEventListener("mouseleave", Swal.resumeTimer)
    },
  })

  useEffect(() => {
    dispatch(getKBentriesSuccess(false))
    dispatch(setKBentries([]))
    dispatch(getKBentries())
  }, [])

  const columns = [
    {
      dataField: "smsc_match",
      text: "SMSC Match",
      sort: true,
    },
    {
      dataField: "smsc_owner_replace",
      text: "SMSC Replace",
      sort: true,
    },
    {
      text: "Action",
      //field: 'operate',
      title: "View",
      //align: 'center',
      //valign: 'middle',
      clickToSelect: false,
      formatter: function (value, row, index) {
        //return '<input name="elementname"  value="'+value+'"/>';
        return (
          <button
            className={`view-btn-tbl ${role === 4 ? "disabled" : ""}`}
            onClick={async () => {
              dispatch(getSelectedKBentry(row.id))
              let setterPromise = new Promise(async (resolve, reject) => {
                store.subscribe(() => {
                  const editSuccess = store.getState()
                  const status = editSuccess.kb.selectedkbsuccess
                  if (status == true) {
                    // console.log(status);
                    resolve("Done")
                  }
                })
              })
              await setterPromise.then(async msg => {
                dispatch(setSelectedKBentriesSuccess(false))
                setTimeout(() => {
                  tog_edit_screen()
                }, 200)
              })
            }}
            disabled={role === 4}
          >
            Edit
          </button>
        )
      },
    },
    {
      text: "Action",
      //field: 'operate',
      title: "View",
      //align: 'center',
      //valign: 'middle',
      clickToSelect: false,
      formatter: function (value, row, index) {
        //return '<input name="elementname"  value="'+value+'"/>';
        return (
          <button
            className={`view-btn-tbl ${role === 4 ? "disabled" : ""}`}
            onClick={async () => {
              deleteKBs(row.id)
            }}
            disabled={role === 4}
          >
            Delete
          </button>
        )
      },
    },
  ]

  const kBdata = useSelector(state => state.kb.kb)
  const uploadState = useSelector(state => state.kb.uploadsuccess)
  const getSuccess = useSelector(state => state.kb.getSuccess)
  const selectedKBdata = useSelector(state => state.kb.selectedkb)
  const tableData = kBdata?.length === 0 ? [] : kBdata?.message ?? []


  const [currentPage, setCurrentPage] = useState(0)
  const itemsPerPage = 10
  const offset = currentPage * itemsPerPage
  const [filteredChannels, setFilteredChannels] = useState([])
  const currentPageItems = filteredChannels.slice(offset, offset + itemsPerPage)
  const [searchTerm, setSearchTerm] = useState("")
  const [searchText, setSearchText] = useState("")

  useEffect(() => {
      setFilteredChannels(tableData)
  }, [kBdata])

  useEffect(() => {
    // console.log(searchTerm,tableData);
    if (searchTerm === "") {
      setFilteredChannels(tableData)
    } else {
      setFilteredChannels(
        tableData.filter(item => {
          // console.log(item);
          let term = searchText.toLowerCase()
          return item.smsc_owner_replace.toLowerCase().includes(term) || item.smsc_match.toLowerCase().includes(term)
        })
      )
      setCurrentPage(0)
    }
  }, [searchTerm])

  const [modal_add_screen, setmodal_add_screen] = useState(false)
  const [modal_edit_screen, setmodal_edit_screen] = useState(false)

  const [input_smscmatch, setinput_smscmatch] = useState("")
  const [input_smscreplace, setinput_smscreplace] = useState("")

  const [edit_smscmatch, setedit_smscmatch] = useState("")
  const [edit_smscreplace, setedit_smscreplace] = useState("")

  function tog_add_screen() {
    setmodal_add_screen(!modal_add_screen)
    removeBodyCss()
  }
  function tog_edit_screen() {
    setmodal_edit_screen(!modal_edit_screen)
    removeBodyCss()
  }
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  async function saveKBData() {
    // var formData = new FormData()
    // formData.append("smsc_match",input_smscmatch)
    // formData.append("smsc_replace",input_smscreplace)
    var data = {
      smsc_match: input_smscmatch,
      smsc_replace: input_smscreplace,
    }
    dispatch(uploadKB(data))

    let uploadPromise = new Promise(async (resolve, reject) => {
      store.subscribe(() => {
        const uploadSuccess = store.getState()
        const status = uploadSuccess.kb.uploadsuccess
        if (status == true) {
          // console.log(status);
          resolve("Done")
        }
      })
    })
    await uploadPromise.then(async msg => {
      Toast.fire({
        icon: "success",
        title: "Saved Successfully!",
      })
      dispatch(setUploadKBSuccess(false))
      setTimeout(() => {
        setinput_smscmatch("")
        setinput_smscreplace("")
        setmodal_add_screen(false)
        dispatch(getKBentriesSuccess(false))
        dispatch(setKBentries([]))
        dispatch(getKBentries())
      }, 700)
    })
  }
  async function saveKBEdit(id) {
    // console.log(id);
    var data = {
      id: id,
      smsc_match: edit_smscmatch == "" ? "no edits" : edit_smscmatch,
      smsc_owner_replace:
        edit_smscreplace == "" ? "no edits" : edit_smscreplace,
    }
    dispatch(editKB(data))

    let editPromise = new Promise(async (resolve, reject) => {
      store.subscribe(() => {
        const editSuccess = store.getState()
        const status = editSuccess.kb.editsuccess
        if (status == true) {
          // console.log(status);
          resolve("Done")
        }
      })
    })
    await editPromise.then(async msg => {
      Toast.fire({
        icon: "success",
        title: "Edits Saved Successfully!",
      })
      dispatch(setEditKBSuccess(false))
      setTimeout(() => {
        setmodal_edit_screen(false)
        setedit_smscmatch("")
        setedit_smscreplace("")
        dispatch(setSelectedKBentries([]))
        dispatch(getKBentriesSuccess(false))
        dispatch(setKBentries([]))
        dispatch(getKBentries())
      }, 700)
    })
  }
  async function deleteKBs(id) {
    Swal.fire({
      title: "Do you really want to Delete the record?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Delete",
      denyButtonText: `Don't Delete`,
    }).then(async result => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        dispatch(deleteKB(id))
        let deletePromise = new Promise(async (resolve, reject) => {
          store.subscribe(() => {
            const deleteSuccess = store.getState()
            const status = deleteSuccess.kb.deletesuccess
            if (status == true) {
              // console.log(status);
              resolve("Done")
            }
          })
        })
        await deletePromise.then(async msg => {
          Toast.fire({
            icon: "success",
            title: "Deleted Successfully!",
          })
          dispatch(setDeleteKBsuccess(false))
          setTimeout(() => {
            dispatch(getKBentriesSuccess(false))
            dispatch(setKBentries([]))
            dispatch(getKBentries())
            setCurrentPage(0)
          }, 700)
        })
      } else if (result.isDenied) {
        Swal.fire("Delete Cancelled", "", "info")
      }
    })
  }

  // Table Data
  const productData = [
    {
      id: 1,
      operatorName: "+94115000001",
      country: "+94115077701",
    },

    {
      id: 2,
      operatorName: "+94115000001",
      country: "+94115077701",
    },

    {
      id: 3,
      operatorName: "+94115000001",
      country: "+94115077701",
    },
  ]
  // const tableData = kBdata?.length==0?productData:kBdata.message;
  const selectedKB_editdata =
    selectedKBdata?.length == 0 ? "" : selectedKBdata.message
  // console.log(selectedKB_editdata)
  // console.log(productData)

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]

  const pageOptions = {
    sizePerPage: 10,
    totalSize: tableData.length, // replace later with size(customers),
    custom: true,
    onSizePerPageChange: size => {
      setSizePerPage(size)
    },
  }

  // Custom Pagination Toggle
  const sizePerPageList = [
    { text: "5", value: 5 },
    { text: "10", value: 10 },
    { text: "15", value: 15 },
    { text: "20", value: 20 },
    { text: "25", value: 25 },
    { text: "All", value: productData.length },
  ]

  // Select All Button operation
  // const selectRow = {
  //   mode: "checkbox",
  // }

  const { SearchBar } = Search

  return (
    <React.Fragment>
      <div>
        {" "}
        {/*className="page-content" */}
        <MetaTags>
          <title>KnowledgeBase</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs title="Settings" breadcrumbItem="KnowledgeBase" />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                <Row className="mb-2">
                  <Col md="8" sm="12">
                    <div className="search-box me-2 mb-2 d-inline-block w-sm-100">
                      <Row>
                        <Col>
                          <div
                            className="me-3"
                            style={{
                              border: "1px solid #D9D9D9",
                              borderRadius: "50px",
                              marginBottom: "10px",
                              minWidth: "210px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <i
                              class="bx bx-search-alt search-icon sm-left-30 ps-2 pe-2 "
                              style={{
                                
                                width: "10px",
                                height: "10px",
                              }}
                            ></i>
                            <input
                              type="text"
                              placeholder="Search"
                              style={{
                                width: "150px",
                                height: "31px",
                                border: "none",
                                borderRadius: "10px",
                                textAlign: "start",
                                borderTopLeftRadius: "20px",
                                borderBottomLeftRadius: "20px",
                                marginTop: "2px",
                                marginLeft:"25px"
                              }}
                              value={searchTerm}
                              onChange={e => {
                                setSearchTerm(e.target.value)
                                setSearchText(e.target.value)
                              }}
                              onKeyDown={e => {
                                if (e.key === "Enter") {
                                  // setPage(1)
                                }
                              }}
                            />
                            {searchTerm !== "" && (
                              // <i className="bx bx-search-alt search-icon sm-left-30" />
                              <i
                                className="fas fa-times me-2 ms-2"
                                style={{
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  // setPage(1)
                                  setSearchTerm("")
                                  setSearchText("")
                                }}
                              ></i>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>

                  <Col md="4" sm="12" className="position-relative ">
                    <div className="d-flex ">
                      <Button
                        color="danger"
                        className="btn btn-custom md-position-absolute ms-auto p-2 bd-highlight"
                        onClick={() => {
                          setTimeout(() => {
                            tog_add_screen()
                          }, 200);
                        }}
                        disabled={role === 4}
                      >
                        Add Instance
                      </Button>
                    </div>
                  </Col>
                </Row>
                <div className="col-12 ms-3">
                    {filteredChannels?.length == 0 ? (
                      getSuccess == false ? (
                        <LoadingSpinner />
                      ) : (
                        <div
                          style={{
                            textAlign: "center",
                            paddingTop: "50px",
                          }}
                        >
                          No Data Found
                        </div>
                      )
                    ) : (
                      <div>

                      <Row style={{ marginRight: "15px" }}>
                      <Table className="table-responsive align-middle mb-0 report_table_edit">
                      <thead>
                        <tr>
                          <th>SMSC Match</th>
                          <th>SMSC Replace</th>
                          <th>Action</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentPageItems?.map(file => {
                          return (
                            <tr key={file.id}>
                              <td>{file.smsc_match}</td>
                              <td>
                                {file.smsc_owner_replace}{" "}
                              </td>
                              <td>
                              <button
                                className={`view-btn-tbl ${role === 4 ? "disabled" : ""}`}
                                onClick={async () => {
                                  dispatch(getSelectedKBentry(file.id))
                                  let setterPromise = new Promise(async (resolve, reject) => {
                                    store.subscribe(() => {
                                      const editSuccess = store.getState()
                                      const status = editSuccess.kb.selectedkbsuccess
                                      if (status == true) {
                                        // console.log(status);
                                        resolve("Done")
                                      }
                                    })
                                  })
                                  await setterPromise.then(async msg => {
                                    dispatch(setSelectedKBentriesSuccess(false))
                                    setTimeout(() => {
                                      tog_edit_screen()
                                    }, 200)
                                  })
                                }}
                                disabled={role === 4}
                              >
                                Edit
                              </button>
                              </td>
                              <td>
                              <button
                                className={`view-btn-tbl ${role === 4 ? "disabled" : ""}`}
                                onClick={async () => {
                                  deleteKBs(file.id)
                                }}
                                disabled={role === 4}
                              >
                                Delete
                              </button>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </Table>
                  </Row>
                      </div>
                    )}
                  </div>
                  <div className="col-12">
                    <ReactPaginate
                      previousLabel={"previous"}
                      nextLabel={"next"}
                      breakLabel={"..."}
                      pageCount={Math.ceil(
                        filteredChannels.length / itemsPerPage
                      )}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      forcePage={currentPage}
                      onPageChange={data => {
                        setCurrentPage(data.selected)
                      }}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                    />
                  </div>
                  {/* Add Instance */}
                  <Modal
                    size="md"
                    isOpen={modal_add_screen}
                    toggle={() => {
                      tog_add_screen()
                    }}
                    className="modal-popscreen"
                  >
                    <div className="modal-header">
                      <h5
                        className="modal-title mt-0"
                        id="exampleModalFullscreenLabel"
                      >
                        SMSC Details
                      </h5>
                      <button
                        onClick={() => {
                          setmodal_add_screen(false)
                        }}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <form>
                        <div className="customer-field-container">
                          <Row>
                            <Col md="4">
                              <label className="lable-customer">
                                SMSC Match
                              </label>
                            </Col>
                            <Col md="8">
                              <Input
                                type="name"
                                className="customer-input"
                                value={input_smscmatch}
                                placeholder="Enter the Number"
                                onChange={e => {
                                  let inputValue = e.target.value.replace(
                                    /[^0-9]/g,
                                    ""
                                  )
                                  if (inputValue.length > 0) {
                                    inputValue = `+${inputValue}`
                                  }
                                  setinput_smscmatch(inputValue)
                                }}
                              />
                              {/* <PhoneInput
                                    className="customer-phone-input"
                                    placeholder="Enter the Number"
                                    onChange={(e)=>{
                                      setinput_smscmatch(e)
                                    }}
                                    /> */}
                            </Col>
                          </Row>
                          <Row>
                            <Col md="4">
                              <label className="lable-customer">
                                SMSC Replace
                              </label>
                            </Col>
                            <Col md="8">
                              <Input
                                type="name"
                                className="customer-input"
                                placeholder="Enter the Name"
                                onChange={e => {
                                  setinput_smscreplace(e.target.value)
                                }}
                              />
                            </Col>
                          </Row>
                        </div>
                      </form>
                    </div>

                    <div className="modal-footer">
                      <button
                        type="button"
                        onClick={() => {
                          tog_add_screen()
                        }}
                        className="btn btn-secondary "
                        data-dismiss="modal"
                      >
                        Close
                      </button>
                      <Button
                        type="button"
                        className="btn btn-primary"
                        onClick={e => {
                          saveKBData()
                        }}
                      >
                        Save
                      </Button>
                    </div>
                  </Modal>

                  {/* Edit */}
                  <Modal
                    size="md"
                    isOpen={modal_edit_screen}
                    toggle={() => {
                      tog_edit_screen()
                    }}
                    className="modal-popscreen"
                  >
                    <div className="modal-header">
                      <h5
                        className="modal-title mt-0"
                        id="exampleModalFullscreenLabel"
                      >
                        Edit SMSC Details
                      </h5>
                      <button
                        onClick={() => {
                          setmodal_edit_screen(false)
                        }}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <form>
                        <div className="customer-field-container">
                          <Row>
                            <Col md="4">
                              <label className="lable-customer">
                                SMSC Match
                              </label>
                            </Col>
                            <Col md="8">
                              <Input
                                type="name"
                                className="customer-input"
                                placeholder="Enter Number"
                                // value={edit_smscmatch}
                                value={selectedKB_editdata.smsc_match}
                                onChange={e => {
                                  let inputValue = e.target.value.replace(
                                    /[^0-9]/g,
                                    ""
                                  )
                                  if (inputValue.length > 0) {
                                    inputValue = `+${inputValue}`
                                  }
                                  selectedKB_editdata.smsc_match = inputValue
                                  setedit_smscmatch(inputValue)
                                }}
                              />
                              {/* <PhoneInput
                                    className="customer-phone-input"
                                    placeholder="Enter phone number"
                                    value={selectedKB_editdata.smsc_match}
                                    onChange={(e)=>{
                                      setedit_smscmatch(e)
                                    }}
                                    /> */}
                            </Col>
                          </Row>
                          <Row>
                            <Col md="4">
                              <label className="lable-customer">
                                SMSC Replace
                              </label>
                            </Col>
                            <Col md="8">
                              <Input
                                type="name"
                                className="customer-input"
                                placeholder="Empty"
                                defaultValue={
                                  selectedKB_editdata.smsc_owner_replace
                                }
                                onChange={e => {
                                  setedit_smscreplace(e.target.value)
                                }}
                              />
                            </Col>
                          </Row>
                        </div>
                      </form>
                    </div>

                    <div className="modal-footer">
                      <button
                        type="button"
                        onClick={() => {
                          tog_edit_screen()
                        }}
                        className="btn btn-secondary "
                        data-dismiss="modal"
                      >
                        Close
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary "
                        onClick={() => {
                          saveKBEdit(selectedKB_editdata.id)
                        }}
                      >
                        Save changes
                      </button>
                    </div>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default KnowledgeBase
